<template>
    <div v-if="hasPermission" class="d-contents">
        <slot></slot>
    </div>
</template>

<script>
import { PERMISSION } from '@/constants/permission.constant';

export default {
    name: 'PermissionWrapper',
    props: {
        pms: {
            type: [String, Array, Object],
            validator: function (value) {
                const permissions = Object.values(PERMISSION);
                if (typeof (value) == "string")
                    return permissions.includes(value);
                else if (Array.isArray(value))
                    return value.some(d => permissions.includes(d));

            },
            required: true,

        }

    },
    computed: {
        hasPermission() {
            return this.$checkPermission(this.pms) || this.$isAdmin();
        }
    }

};
</script>

<style scoped>
.d-contents {
    display: contents;
}
</style>